import { render } from "./EditingParametersCore.vue?vue&type=template&id=4993b97e"
import script from "./EditingParametersCore.vue?vue&type=script&lang=js"
export * from "./EditingParametersCore.vue?vue&type=script&lang=js"
script.render = render

export default script